const globals = {
    // Constants
    backendPublicKeyRaw: "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAzH67cxzIY2fykcN1PaS1p5DjT2AwrNuF2CT8TtNlTwidixmEUrpNqU5HYXrt6uJNcof3hLUMor4gjvYA/M6tPVNRFEZLqDOR5ZWm6XeoeJQ/HtSNjt06utX/HvUSE89DsSa3244VmS6Q/KYq39171xTyy5lWlh9/60FcyGul/WK7A4MGDNjCc24SCcs4Z+27aobj1/OPDZNEhSEgYrzgw9LJbxQg4/Hd/9GpC9YkNW93717/07JcoBuTWMvHME7HUy5Np1At34pBjOs6xfm8htszZir0qd8MnTOQyPPcpwZhItM/dkVZsYa2Ua2rWVMMFhO2P993CXVFLl12IR93zwIDAQAB",
    serverUrl: process.env.REACT_APP_SERVER_URL ?? (process.env.NODE_ENV === 'production'
        ? 'https://api.aurecas.net/api/'
        : 'http://localhost:7029/api/'),
    apiLogin: process.env.REACT_APP_API_LOGIN ?? 'GmLogin?code=mceeXwVLVfcvs14Ld8MJ7l-hZpRDgu4Tp6dM6Qm7KblGAzFuW4F99Q==',
    apiEntryPoint: process.env.REACT_APP_API_ENTRY_POINT ?? 'GmEntryPoint?code=_p8PdKLMybC0TQKwI1mAEfbUBPI1GKFWI56kPVRYySr4AzFuXBoJHQ==',
    googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID ?? '565678787345-ru0431f0n77ma1fret7ii5aicmf39mod.apps.googleusercontent.com',
    languageNames: {
        "EN": "English", "PT": "Portuguese", "ID": "Indonesian", "KO": "Korean", "TR": "Turkish", "AZ": "Azerbaijani", "PL": "Polish",
        "FR": "French", "FA": "Persian", "HI": "Hindi", "AR": "Arabian", "VI": "Vietnamese", "ZH": "Chinese", "IT": "Italian",
        "TH": "Thai", "DE": "German", "ES": "Spanish", "RU": "Russian", "JA": "Japanese", "AF": "Afrikaans", "SQ": "Albanian",
        "BS": "Bosnian", "CA": "Catalan", "DA": "Danish", "SK": "Slovak", "SL": "Slovenian", "ET": "Estonian", "FI": "Finnish",
        "RO": "Romanian", "SV": "Swedish", "CS": "Czech", "UZ": "Uzbek", "ZU": "Zulu", "NL": "Dutch", "HU": "Hungarian", "LT": "Lithuanian",
        "MS": "Malay", "BE": "Belarusian", "BG": "Bulgarian", "KK": "Kazakh", "MK": "Macedonian", "MN": "Mongolian", "SR": "Serbian",
        "UK": "Ukrainian", "IW": "Hebrew", "MR": "Marathi"
    },
    platformNames: ["Android", "iOS", "Web", "Steam"],
    // ISO 3166-1 alpha-2, the backend's CountryMapping.CountryCode list (names come from Intl.DisplayNames)
    countryCodes: ["US", "CA", "BR", "MX", "AR", "CO", "CL", "PE", "VE", "EC", "GT", "CU", "BO", "DO", "HN", "PY", "SV", "NI", "CR", "PA", "UY", "HT", "JM", "TT", "GY",
        "SR", "BZ", "BS", "KN", "DM", "AG", "GD", "VC", "LC", "BB", "PR", "VI", "AS", "MP", "GU", "UM", "GF", "GP", "MQ", "BL", "MF", "PM", "AW", "CW", "SX",
        "BQ", "VG", "KY", "TC", "MS", "AI", "FK", "GS", "GB", "DE", "FR", "IT", "ES", "PT", "PL", "UA", "RO", "NL", "BE", "SE", "NO", "DK", "FI", "CH", "AT",
        "HU", "CZ", "SK", "GR", "BG", "HR", "RS", "BY", "IE", "GE", "BA", "AM", "LT", "AL", "SI", "MK", "LV", "ME", "EE", "LU", "MT", "IS", "CY", "MD", "XK",
        "AD", "SM", "MC", "LI", "VA", "FO", "GL", "GI", "BM", "GG", "JE", "IM", "SJ", "AX", "RE", "YT", "TF", "SH", "IO", "JP", "KR", "CN", "TW", "HK", "SG",
        "IN", "ID", "PH", "VN", "TH", "MY", "PK", "BD", "SA", "AE", "IL", "IQ", "IR", "TR", "RU", "KZ", "UZ", "AZ", "AF", "MM", "SY", "KP", "YE", "NP", "LK",
        "KH", "TJ", "PG", "LA", "KG", "TM", "JO", "PS", "OM", "KW", "QA", "MN", "BN", "TL", "BT", "MV", "CM", "BH", "LB", "MH", "FM", "PW", "NR", "TV", "TO",
        "MO", "CK", "NU", "NF", "CX", "CC", "ZA", "EG", "NG", "KE", "MA", "GH", "ET", "TZ", "CD", "SD", "DZ", "UG", "AO", "MZ", "MG", "CI", "NE", "BF", "ML",
        "MW", "ZM", "SO", "TD", "SN", "ZW", "GN", "SS", "RW", "BJ", "BI", "TN", "TG", "LY", "SL", "CF", "CG", "LR", "MR", "GA", "GM", "LS", "GW", "GQ", "ER",
        "NA", "BW", "DJ", "KM", "SZ", "MU", "CV", "ST", "SC", "EH", "AU", "NZ", "FJ", "SB", "VU", "WS", "KI", "PF", "NC", "TK", "WF", "PN", "AQ", "BV", "HM",
],
    branches: ["Production", "Beta", "Internal", "Development"],
    branchFlags: {
        None:        0,
        Production:  1 << 0,
        Beta:        1 << 1,
        Internal:    1 << 2,
        Development: 1 << 3
    },

    // Vars
    loginData: {},
    privateKey: null,
    privateKeyDecrypt: null,
    backendPublicKey: null,
    backendPublicKeyEncrypt: null,
    selectedTitle: "",
    route: null,        // { title, page, sub, deep[] } of the page on screen (Layout/Router.js); pages read their deep link here
    routeNonce: 0,      // bumped when a deep link is opened, so the page mounts fresh

    // Methods
    branchToFlags(branch) {
        switch(branch) {
            case "Production":
                return this.branchFlags.Production;
            case "Beta":
                return this.branchFlags.Beta;
            case "Internal":
                return this.branchFlags.Internal;
            case "Development":
                return this.branchFlags.Development;
            default:
                return this.branchFlags.None;
        }
    },

    addBranchFlags(flags, branch) {
        return flags | this.branchToFlags(branch);
    },

    removeBranchFlags(flags, branch) {
        return flags & ~this.branchToFlags(branch);
    },

    checkBranchFlags(flags, branch) {
        return (flags & this.branchToFlags(branch)) !== this.branchFlags.None;
    },

    setBranchFlags(branchArray) {
        let flags = this.branchFlags.None;
        for (const branch of branchArray) {
            flags |= this.branchToFlags(branch);
        }
        return flags;
    },

    compactVersion(major, minor, patch, branch = null) {
        if (branch == null) branch = 0;
        return ((branch & 0x3) << 29) | ((major & 0xFF) << 21) | ((minor & 0xFF) << 13) | (patch & 0x1FFF);
    },

    versionChangePatch(version, patch) {
        const { branch, major, minor } = this.decompactVersion(version);
        return this.compactVersion(major, minor, patch, branch);
    },

    decompactVersion(version) {
        const patch = version & 0x1FFF;
        const minor = (version >> 13) & 0xFF;
        const major = (version >> 21) & 0xFF;
        const branch = (version >> 29) & 0x3;
        return { branch, major, minor, patch };
    }
};

export default globals;